export const routes = [
    { path: '/', breadcrumb: 'Home' },
    { path: '/category/:category', breadcrumb: ':category' },
    { path: '/category/:category/:subcategory', breadcrumb: ':subcategory' },
    { path: '/team', breadcrumb: 'Team' },
    { path: '/team/:authorSlug', breadcrumb: ':authorSlug' },
    { path: '/tags/:slug', breadcrumb: ':slug' },
    { path: '/articles/:id', breadcrumb: 'Articolo' },
    { path: '/preview/:id', breadcrumb: 'Anteprima' },
  ];